import React, { Component } from 'react';
import { Link } from 'react-router';
import { Tooltip, OverlayTrigger} from 'react-bootstrap';
import Loading from '../../../components/Loading/Loading';

import openInNewIcon from '../../../assets/img/open-in-new-black.svg';

import AnalysisItem from './AnalysisItem';

class InsightCardItem extends Component {
  render() {
    return (
      <div className={`card-item ${this.props.className}`}>
        <div className='card-header'>
          <h4>
            {this.props.name}
            {this.props.status && this.props.status !== 'notenoughdata' &&
              <OverlayTrigger 
                placement="bottom" 
                overlay={
                  <Tooltip id="Tooltip" className='tooltip_dark'>
                    <p>
                      For more details, view the {this.props.chartName} here
                    </p>
                  </Tooltip>
                }
              >
                <Link to={`/dashboard/${this.props.dashboardId}/${this.props.chart}`} target="_blank"><img src={openInNewIcon} alt="#" /></Link>
              </OverlayTrigger>
            }
          </h4>

          <div className='card-status'>
            {this.props.status}
          </div>
        </div>

        <div className='card-content'>
          {!this.props.status && (
            <Loading />
          )}
          <AnalysisItem
            key={this.props.analisisLabelText ? this.props.analisisLabelText.replace(/ /g, ''): Math.random()}
            labelText={this.props.analisisLabelText}
            values={this.props.chartValues}
            valueType={this.props.valueType}
          ></AnalysisItem>

          <div className='notenoughdata-badge'></div>

          <div className='card-info'>
            <div className='card-info-description'>
              <p key='description'>{this.props.description}</p>
              <OverlayTrigger 
                placement="right" 
                overlay={
                  <Tooltip id="Tooltip" className='tooltip_dark max_width'>
                    <p>{this.props.text}</p>
                  </Tooltip>
                }
              >
                <span className="more_info" />
              </OverlayTrigger>
            </div>

            {this.props.children}
          </div>

          
        </div>
      </div>
    )
  }
}

export default InsightCardItem;
